var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacilityLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#91C6E0"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M455.579,74.469v341.87c-7.753,9.644-16.196,18.714-25.255,27.136 c-10.689,9.958-22.246,18.996-34.523,27.011c-40.187,26.258-88.21,41.514-139.797,41.514s-99.61-15.266-139.807-41.514 c-12.278-8.025-23.834-17.063-34.523-27.021c-9.059-8.422-17.502-17.492-25.255-27.136V74.469H455.579z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.417,
    y: 74.47,
    style: {
      fill: "#E6E5E5"
    },
    width: 399.161,
    height: 50.155
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263E82"
    },
    d: "M476.999,68.314v20.668c0,10.449-8.474,18.923-18.923,18.923H53.93 c-10.459,0-18.923-8.474-18.923-18.923V68.314c0-10.449,8.464-18.923,18.923-18.923h404.146 C468.525,49.391,476.999,57.865,476.999,68.314z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#384E99"
    },
    d: "M476.999,68.314v7.084c0,10.449-8.474,18.923-18.923,18.923H53.93 c-10.459,0-18.923-8.474-18.923-18.923v-7.084c0-10.449,8.464-18.923,18.923-18.923h404.146 C468.525,49.391,476.999,57.865,476.999,68.314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#384E99"
    },
    d: "M81.673,278.297V173.662c0-7.462,6.049-13.511,13.511-13.511h70.33 c7.462,0,13.511,6.049,13.511,13.511v104.635c0,7.462-6.049,13.511-13.511,13.511H95.185 C87.723,291.809,81.673,285.759,81.673,278.297z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 96.507,
    y: 174.989,
    style: {
      fill: "#C5DEEA"
    },
    width: 67.683,
    height: 101.993
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 88.168,
    y: 199.095,
    style: {
      fill: "#384E99"
    },
    width: 84.376,
    height: 15.768
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#384E99"
    },
    d: "M207.322,278.297V173.662c0-7.462,6.049-13.511,13.511-13.511h70.33 c7.462,0,13.511,6.049,13.511,13.511v104.635c0,7.462-6.049,13.511-13.511,13.511h-70.33 C213.371,291.809,207.322,285.759,207.322,278.297z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 222.156,
    y: 174.989,
    style: {
      fill: "#C5DEEA"
    },
    width: 67.683,
    height: 101.993
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 213.807,
    y: 199.095,
    style: {
      fill: "#384E99"
    },
    width: 84.376,
    height: 15.768
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#384E99"
    },
    d: "M332.97,278.297V173.662c0-7.462,6.049-13.511,13.511-13.511h70.33 c7.462,0,13.511,6.049,13.511,13.511v104.635c0,7.462-6.049,13.511-13.511,13.511h-70.33 C339.019,291.809,332.97,285.759,332.97,278.297z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 347.805,
    y: 174.989,
    style: {
      fill: "#C5DEEA"
    },
    width: 67.683,
    height: 101.993
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 339.456,
    y: 199.095,
    style: {
      fill: "#384E99"
    },
    width: 84.376,
    height: 15.768
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#384E99"
    },
    d: "M179.025,352.339v104.636c0,7.461-6.05,13.51-13.511,13.51h-49.319 c-12.278-8.025-23.834-17.063-34.523-27.021v-91.126c0-7.461,6.05-13.511,13.511-13.511h70.332 C172.976,338.828,179.025,344.878,179.025,352.339z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 96.507,
    y: 353.667,
    style: {
      fill: "#C5DEEA"
    },
    width: 67.683,
    height: 101.993
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 88.168,
    y: 377.772,
    style: {
      fill: "#384E99"
    },
    width: 84.376,
    height: 15.768
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#384E99"
    },
    d: "M207.322,456.975V352.34c0-7.462,6.049-13.511,13.511-13.511h70.33 c7.462,0,13.511,6.049,13.511,13.511v104.635c0,7.462-6.049,13.51-13.511,13.51h-70.33 C213.371,470.486,207.322,464.436,207.322,456.975z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 222.156,
    y: 353.667,
    style: {
      fill: "#C5DEEA"
    },
    width: 67.683,
    height: 101.993
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 213.807,
    y: 377.772,
    style: {
      fill: "#384E99"
    },
    width: 84.376,
    height: 15.768
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#384E99"
    },
    d: "M430.323,352.339v91.136c-10.689,9.958-22.246,18.996-34.523,27.011h-49.319 c-7.461,0-13.511-6.05-13.511-13.51V352.339c0-7.461,6.05-13.511,13.511-13.511h70.332 C424.273,338.828,430.323,344.878,430.323,352.339z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 347.805,
    y: 353.667,
    style: {
      fill: "#C5DEEA"
    },
    width: 67.683,
    height: 101.993
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.456,
    y: 377.772,
    style: {
      fill: "#384E99"
    },
    width: 84.376,
    height: 15.768
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5DEEA"
    },
    d: "M205.942,140.095h100.115c9.387,0,16.996-7.61,16.996-16.996V22.983 c0-9.387-7.61-16.996-16.996-16.996H205.942c-9.387,0-16.996,7.61-16.996,16.996v100.115 C188.946,132.485,196.556,140.095,205.942,140.095z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5B47"
    },
    d: "M216.677,89.251c0,0.541,0.005,1.081,0.015,1.62c0.941,50.99,77.674,50.99,78.614,0 c0.01-0.539,0.015-1.078,0.015-1.62c0-30.301-15.658-56.943-39.323-72.283C232.336,32.308,216.677,58.949,216.677,89.251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M283.699,72.561h-13.104c-2.221,0-4.022-1.8-4.022-4.022V55.435c0-2.221-1.8-4.022-4.022-4.022 h-13.103c-2.221,0-4.022,1.8-4.022,4.022v13.104c0,2.221-1.8,4.022-4.022,4.022h-13.104c-2.221,0-4.022,1.8-4.022,4.022v13.104 c0,2.221,1.8,4.022,4.022,4.022h13.104c2.221,0,4.022,1.8,4.022,4.022v13.104c0,2.221,1.8,4.022,4.022,4.022h13.104 c2.221,0,4.022-1.8,4.022-4.022V97.729c0-2.221,1.8-4.022,4.022-4.022H283.7c2.221,0,4.022-1.8,4.022-4.022V76.583 C287.721,74.361,285.921,72.561,283.699,72.561z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilityLogo);
export default __webpack_public_path__ + "static/media/facility-logo.9fc24414a1612de7dced6f5ec93c2457.svg";
export { ForwardRef as ReactComponent };